<template>
    <div class="uk-padding-large uk-background-secondary" >
        <div class="uk-container uk-light">
            <h3 class="uk-heading-bullet">Share and Inspire</h3>
            <p>Your story can be the inspiration to a student that is need to hear it. Ensure that persons with similar experiences can draw strength from the fact that
            you overcame your hurdles.</p>
            <button class="uk-button uk-button-default uk-align-center">Write your Story</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shareStory"
    }
</script>

<style scoped>

</style>